import { render, staticRenderFns } from "./SizeAndQuantity.vue?vue&type=template&id=e613fd00&"
import script from "./SizeAndQuantity.vue?vue&type=script&lang=js&"
export * from "./SizeAndQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports